import { __decorate } from "tslib";
import { AsnProp, AsnPropTypes, AsnType, AsnTypeTypes } from "@peculiar/asn1-schema";
import { DirectoryString } from "@peculiar/asn1-x509";
export const id_enrollCertType = "1.3.6.1.4.1.311.20.2";
export class EnrollCertType {
    constructor(params = {}) {
        this.name = "";
        Object.assign(this, params);
    }
}
__decorate([
    AsnProp({ type: AsnPropTypes.Utf8String })
], EnrollCertType.prototype, "name", void 0);
let EnrollCertTypeChoice = class EnrollCertTypeChoice {
    constructor(params = {}) {
        Object.assign(this, params);
    }
    toString() {
        var _a, _b;
        return ((_a = this.name) === null || _a === void 0 ? void 0 : _a.toString()) || ((_b = this.spec) === null || _b === void 0 ? void 0 : _b.name) || "";
    }
};
__decorate([
    AsnProp({ type: DirectoryString })
], EnrollCertTypeChoice.prototype, "name", void 0);
__decorate([
    AsnProp({ type: EnrollCertType })
], EnrollCertTypeChoice.prototype, "spec", void 0);
EnrollCertTypeChoice = __decorate([
    AsnType({ type: AsnTypeTypes.Choice })
], EnrollCertTypeChoice);
export { EnrollCertTypeChoice };
